import { useEffect, useState } from 'react';
import { medicosAPI, tiposEstudiosAPI } from '../../../core/api/api';

// Clave de un canal de equipo: combinación (canales, conCpap).
export const claveCanal = (c) => `${c.canales}-${c.conCpap ? 1 : 0}`;

// Nombre legible de un canal: "Canal 4", "Canal 4 con CPAP", "Canal 0 con CPAP".
export const nombreCanal = (c) => `Canal ${c.canales}${c.conCpap ? ' con CPAP' : ''}`;

// Datos para cargar los estudios de un horario de técnico:
// - tiposEstudios: todos los tipos de estudio.
// - canalesPorEstudio: { [idTipoEstudio]: [{ canales, conCpap, etiqueta }] } canales habilitados
//   para cada estudio (sin entrada = acepta cualquier canal).
// - opcionesCanales: canales de la sede según sus equipos [{ canales, conCpap, etiqueta, equipos }].
// Solo carga cuando `activo` es true (horario de técnico).
export const useOpcionesCapacidad = (activo, idCentro) => {
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [canalesPorEstudio, setCanalesPorEstudio] = useState({});
  const [opcionesCanales, setOpcionesCanales] = useState([]);
  const [loadingCanales, setLoadingCanales] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activo) return;
    let cancelado = false;
    const cargar = async () => {
      try {
        const [rTipos, rCanalesTipos] = await Promise.all([
          tiposEstudiosAPI.getTiposEstudios(),
          tiposEstudiosAPI.getCanalesTiposEstudio(),
        ]);
        if (cancelado) return;
        setTiposEstudios(rTipos.data || []);
        const mapa = {};
        (rCanalesTipos.data || []).forEach(c => {
          mapa[c.idTipoEstudio] = [...(mapa[c.idTipoEstudio] || []), c];
        });
        setCanalesPorEstudio(mapa);
      } catch {
        if (!cancelado) setError('No pudimos cargar los tipos de estudio.');
      }
    };
    cargar();
    return () => { cancelado = true; };
  }, [activo]);

  useEffect(() => {
    if (!activo || !idCentro) { setOpcionesCanales([]); return; }
    let cancelado = false;
    const cargar = async () => {
      setLoadingCanales(true);
      try {
        const r = await medicosAPI.getOpcionesCanales(idCentro);
        if (!cancelado) setOpcionesCanales(r.data || []);
      } catch {
        if (!cancelado) setError('No pudimos cargar los canales de la sede.');
      } finally {
        if (!cancelado) setLoadingCanales(false);
      }
    };
    cargar();
    return () => { cancelado = true; };
  }, [activo, idCentro]);

  return { tiposEstudios, canalesPorEstudio, opcionesCanales, loadingCanales, error };
};
